module.exports = "/_next/static/images/screen-consultation-3-a7d887e2a09dce4269c1a3c0b53a2400.png";